export interface PlanLayerColors
{
    planColor: string;
    pastTrailColor: string;
    waypointFillColor: string;
}

// Amber ring drawn around waypoints that exceed the allowed deviation from the top-1 star route
// (10 nm rhumbline / 50 nm great circle). Shared by the planning and route-edit layers.
export const STAR_ROUTE_DEVIATION_AMBER = "#FFA500";

export interface PlanningLayersColors {
    defaultColor: string;
    uiRouteColors: string[];
    warningColor: string;
    avoidColor: string;
    waypointFillColor: string;
    parametricRollColor: string;
    passedColor: string;
    heavyRollingColor: string;
    transverseAccelerationColor: string;
  }
